import {types} from 'mobx-state-tree';

const ServerEngineModel = types.model("ServerEngineModel", {
  id: types.optional(types.identifierNumber, 0),
  driver: types.optional(types.number, 0),
  engineName: types.optional(types.string, ""),
});

export default ServerEngineModel;